import * as MicrosoftGraph from '@microsoft/microsoft-graph-types';
import { getSentItemsFolderId } from './graphApi';
import { getUserEmail, isSameEmail } from './outlookItemUtils';

const TAG = 'GIU1: ';

export async function getDirectionForGraphItem(item: MicrosoftGraph.Message) {
  const userEmail = getUserEmail(undefined);
  const senderEmail = item.from.emailAddress.address;

  if (isSameEmail(senderEmail, userEmail)) return 'OUT';

  // Messages sent from one of the user's aliases don't match the user's email, but are in Sent Items
  try {
    return item.parentFolderId === (await getSentItemsFolderId())
      ? 'OUT'
      : 'IN';
  } catch (error) {
    console.error(TAG, 'Failed to check if item is in Sent Items', error);
    return 'IN';
  }
}
